import { Checkbox, Radio } from '@material-ui/core';
import React from 'react';
import styles from './StepSelector.module.css';
import classNames from 'classnames';
export var StepSelector = function (props) {
    var _a;
    var containerClasses = classNames(styles.container, (_a = {},
        _a[styles.active] = props.active,
        _a[styles.error] = !!props.error && props.active,
        _a));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: containerClasses, onClick: function () {
                props.onClick(!props.value);
            } },
            React.createElement("div", { className: styles.icon }, props.useCheckbox ? (React.createElement(Checkbox, { checked: props.active, "data-test-id": props.testId, className: styles.checkbox })) : (React.createElement(Radio, { checked: props.active, value: props.value, "data-test-id": props.testId }))),
            React.createElement("div", { className: styles.information },
                React.createElement("div", { className: styles.title }, props.text),
                React.createElement("div", { className: styles.info }, props.info))),
        props.error && React.createElement("div", { className: styles.errorMessage }, props.error)));
};
